/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TxtTemplate } from '../../models/txt-template';

export interface GetTxtTemplates$Params {
}

export function getTxtTemplates(http: HttpClient, rootUrl: string, params?: GetTxtTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TxtTemplate>>> {
  const rb = new RequestBuilder(rootUrl, getTxtTemplates.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TxtTemplate>>;
    })
  );
}

getTxtTemplates.PATH = '/api/template/abreviations';
